<template>
  <a :href="to" @click="goTo($event, to)" :target="target" class="card-link">
    <header :style="`${backgroundColor ? `background-color: ${backgroundColor}` : ''}`">
      <div class="circle" :style="`background-color: ${circleColor || 'rgba(255, 255, 255, .2)'}`"></div>
      <i :class="`icon-${icon}`" v-if="icon" :style="`color: ${backgroundColor}`" />
    </header>
    <section>
      <h2 v-if="title">{{ title }}</h2>
      <p v-if="text">{{ text }}</p>
      <i class="icon-back-arrow"></i>
    </section>
  </a>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: true,
    },
    backgroundColor: {
      type: String,
      default: '',
    },
    circleColor: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
  },
  methods: {
    goTo(event, to) {
      if (to.substr(0, 4) !== 'http' && !event.metaKey) {
        event.preventDefault();
        this.$router.push(to);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-link {
  border-radius: 8px;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, .04), 0 2px 4px 0 rgba(0, 0, 0, .04);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  header {
    min-height: 160px;
    padding-top: 35%;
    position: relative;

    i {
      font-size: 64px;
      left: calc(50% - 32px);
      position: absolute;
      top: calc(50% - 32px);
    }

    .circle {
      border-radius: 52px;
      height: 104px;
      left: calc(50% - 52px);
      position: absolute;
      top: calc(50% - 52px);
      width: 104px;
      transition: filter .3s;
    }
  }

  section {
    background-color: white;
    flex: 1;
    padding: 22px 50px 22px 22px;
    position: relative;

    h2 {
      font-weight: 500;
      font-size: 18px;
      color: #000000;
      line-height: 24px;
    }

    p {
      font-weight: 400;
      font-size: 15px;
      color: #868B97;
      line-height: 20px;
    }

    i {
      font-size: 20px;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      color: #0060FF;
    }
  }

  &:hover {
    cursor: pointer;

    .circle {
      filter: brightness(70%);
    }
  }

  @media (min-width: 768px) {
    flex: 1;
    max-width: 480px;
  }
}
</style>
